import * as React from "react";

import "./service-level-col.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {formatDate1}    from "@Common/ui-components/format-date";

import {setShippingServiceLevel} from "../../../store/actions/shipping/set-shipping-service-level";
import {formatServiceLevelName}  from "../../common/service-level/format-service-level-name";
import {ShippingRateModal}       from "../../common/service-level/shipping-rate-modal/shipping-rate-modal";

export const ServiceLevelCol = ({store, apiError, next}) => cs(
    ["shippingRateModal", ({}, next) => ShippingRateModal({next})],
    ({shippingRateModal}) => next({
        render: ({item}) => cs(

            ({}, next) => apiError.value ? (
                <div className="service-level-col-41y">
                    <div className="error" xd-qa-type="label" xd-qa-name="Service Level Error">
                        {apiError.value}
                    </div>
                </div>
            ) : item.shipping && (
                next()
            ),

            consumeContext("apis"),
            consumeContext("userLevels"),
            ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
            ({apis, isInternalUser}) => (
                <div className="service-level-col-41y">
                    <div className="line1">
                        <div className="name" xd-qa-type="label" xd-qa-name={`Service Level ${item.itemId}`}>
                            {formatServiceLevelName(item.shipping.serviceLevel)}
                        </div>

                        <div className="actions">
                            <a
                                onClick={() => shippingRateModal.show({
                                    fetch: () => apis.next.shipping.getConsolidatedShippingRates({
                                        addressId: item.shipping.addressId,
                                        cartId: store.cart.cartId,
                                        isInternalUser,
                                        itemId: item.itemId,
                                    }),
                                    selected: item.shipping.serviceLevel,
                                    onSelect: async (rate) => {
                                        await store.dispatch(setShippingServiceLevel(rate, {
                                            itemId: item.itemId,
                                            addressId: item.shipping.addressId,
                                            apis,
                                        }));
                                    },
                                })}
                                xd-qa-type="link"
                                xd-qa-name={`Edit Service Level ${item.itemId}`}
                            >Edit</a>
                        </div>
                    </div>
                    {(item.shipping.estimatedDeliveryDate) ?
                        <div className="est-delivery">
                            <div className="label" xd-qa-type="label" xd-qa-name={`Estimated delivery Date ${item.itemId}`}>
                                EST. DELIVERY DATE
                            </div>
                            <div className="value" xd-qa-type="label" xd-qa-name={`Estimated delivery Date ${item.itemId}`}>
                                {formatDate1(new Date(item.shipping.estimatedDeliveryDate))}
                            </div>
                        </div>
                    :
                        <div className="est-delivery">
                            <div className="ship-error" xd-qa-type="label" xd-qa-name={`Estimated delivery Date ${item.itemId}`}>
                                {'The cost and estimated ship date will be provided during processing.'}
                            </div>
                        </div>
                    }
                </div>
            ),
        ),
    }),
);
